const handleToFixedNum = (total, num) => {
  if (total && num !== undefined) {
    if (Number(num) > 1) {
      return Number(num).toFixed(2);
    } else {
      return Number(num).toFixed(4);
    }
  }
  return "XXX";
};

export default handleToFixedNum;
